import { useEffect } from "react";
import ReactDOM from "react-dom";

export const useMapControl = (
  map: any | null,
  controlPosition: google.maps.ControlPosition | null,
  children: any,
  styleClass: string
) => {
  useEffect(() => {
    if (map && controlPosition) {
      const controlButtonDiv = document.createElement("div");
      controlButtonDiv.className = styleClass;
      ReactDOM.render(children, controlButtonDiv);
      map.map.controls[controlPosition].push(controlButtonDiv);
    }
    return () => {
      if (map && controlPosition) {
        map.map.controls[controlPosition].clear();
      }
    };
  }, [map, controlPosition, children, styleClass]);
};
